import React, { FunctionComponent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setContentQuickView,
  setToggleModalQuickView,
} from "../../../actions/searchBoxAction";
import * as ReactRedux from "react-redux";

let ModalQuickView: FunctionComponent<any> = (props) => {
  const dispatch = useDispatch();
  const [toggleModalQuickView, setIsToggleModalQuickView] = useState('')
  const [contentQuickView, setIsContentQuickView] = useState('')
  const [clickUrl, setClickUrl] = useState('')
  const [title, setTitle] = useState('')
  useEffect(() => {
    setIsToggleModalQuickView(props.toggleModalQuickView);
  },[props.toggleModalQuickView]);
  useEffect(() => {
    setIsContentQuickView(props.contentQuickView);
  },[props.contentQuickView]);
  useEffect(() => {
    setClickUrl(props.clickUrl);
  },[props.clickUrl]);
  useEffect(() => {
    setTitle(props.title);
  },[props.title]);

  // let toggleModalQuickView = useSelector(
  //   (state: any) => state.searchBoxReducer.toggleModalQuickView
  // );
  // let contentQuickView='';
  // contentQuickView = useSelector(
  //   (state: any) => state.searchBoxReducer.contentQuickView
  // );
  // let clickUrl = '';
  // clickUrl = useSelector(
  //   (state: any) => state.searchBoxReducer.clickUrl
  // );
  // let title ='';
  // title = useSelector((state: any) => state.searchBoxReducer.title);
  const iframeTitle = `quickview of ${props.title}`;

  async function closeModal(): Promise<void> {
    const modal = document.getElementById("quickViewModal");
    if (modal) {
      modal.style.display = "none";
    }
    await props.dispatch(
      setToggleModalQuickView({
        toggleModalQuickView: false,
      })
    );
    await props.dispatch(
      setContentQuickView({
        contentQuickView: '',
        clickUrl: '',
        title:'',
        valueToggleModal:false
      })
    );
  }
  return (
    <div className="quickview-modal" id="quickViewModal">
      {toggleModalQuickView && (
        <div className="quickview-modal-content">
          <span className="close" onClick={() => closeModal()}>&times;</span>
          <a className="quickview-title" href={clickUrl as string} target="_blank">{title}</a>
          <iframe id="quickview-iframe" srcDoc={contentQuickView} title={iframeTitle}></iframe>
        </div>
      )}
    </div>
  );
};
ModalQuickView = ReactRedux.connect((state: any, ownProps) => {
  return {
    ...ownProps,
    actionFilter: state.searchBoxReducer.actionFilter,
    actionSearchBox: state.searchBoxReducer.actionSearchBox,
    searchClearFilter: state.searchBoxReducer.searchClearFilter,
    toggleModalQuickView : state.searchBoxReducer.toggleModalQuickView ,
    contentQuickView:state.searchBoxReducer.contentQuickView,
    clickUrl:state.searchBoxReducer.clickUrl,
    title: state.searchBoxReducer.title,
  };
})(ModalQuickView);

export default ModalQuickView;

